import { Info as InfoIcon } from "@mui/icons-material";
import { Alert, Link } from "@mui/material";
import type { FC } from "react";
import { Link as RouterLink } from "react-router-dom";
import { useProductWithId } from "../useProductWithId";

interface Props {
  readonly productId: string;
  readonly optionId: string;
}

const PriceListFromOtherOption: FC<Props> = ({ productId, optionId }) => {
  const { product } = useProductWithId(productId);
  const productName = product?.name;
  const optionName = product?.options.find((o) => o.id === optionId)?.name;
  const name = productName && optionName ? ` ${productName} ${optionName}` : "innej opcji";
  return (
    <Alert icon={<InfoIcon fontSize="inherit" />} severity="info">
      Edycja cen niedostępna. Wykorzystywany jest cennik{" "}
      <Link component={RouterLink} to={`/admin/products/${productId}`}>
        {name}
      </Link>
    </Alert>
  );
};

export default PriceListFromOtherOption;
